import React from "react";
import { QuestionType } from "../../../Utils/enum";
import { useTranslation } from "react-i18next";
import { cn, renderWithBold } from "../../../Utils/helper";

const QuestionCard = ({
  text,
  stt,
  typeQuestion,
  questReviewErrors,
  requiredOption,
}) => {
  const { t } = useTranslation();

  const questionTypeText = {
    [QuestionType.MCQ]: renderWithBold(
      t("quest.detailMultipleChoice.chooseOneOption")
    ),
    [QuestionType.YESNO]: t("quest.detailMultipleChoice.chooseOneAnswer"),
    [QuestionType.CHECKBOX]: renderWithBold(
      requiredOption !== undefined &&
        requiredOption !== null &&
        requiredOption !== 0
        ? t("quest.detailMultipleChoice.chooseMultipleOptionsRequired", {
            requiredOption,
          })
        : t("quest.detailMultipleChoice.chooseMultipleOptions")

      // t("quest.detailMultipleChoice.chooseMultipleOptions")
    ),
    [QuestionType.SHORT]: t("quest.detailMultipleChoice.shortAnswerQuestion"),
    [QuestionType.LONG]: t("quest.detailMultipleChoice.elaboratePerson"),
    [QuestionType.SLIDER]: "", // hoặc nội dung phù hợp
  };
  return (
    // <div className="flex-1 shrink gap-2.5 px-3 pt-3 pb-11 w-full text-base bg-yellow-50 rounded-xl border border-solid border-stone-200 min-h-[130px] text-zinc-800">
    //   {stt + 1}. {text}
    // </div>

    <div className="flex flex-col ">
      <h6
        className={cn(
          "text-lg font-bold mb-2 ",
          questReviewErrors?.hint ? "text-[#EF4056]" : "text-[#253FF6]"
        )}
      >
        Q{stt}
      </h6>
      <span className="text-xl font-medium text-[#333]">{text}</span>
      <span className="text-sm text-gray-600 mt-1">
        {questionTypeText[typeQuestion] || ""}
      </span>
    </div>
  );
};

export default QuestionCard;
